<div
	*ngIf="resultConfig?.result"
	class="result-wrapper text-center"
>

	<!-- Icon -->
	<i
		*ngIf="resultConfig?.showIcon"
		class="d-block fs-48 icon-check text-success"
	></i>

	<!-- Pre-Message text -->
	<ng-container
		[ngTemplateOutlet]="additionalFormattedDescriptionsTpl"
		[ngTemplateOutletContext]="{ placement: resultViewPlacementEnum.BEFORE_MESSAGE }"
	></ng-container>

	<!-- Message (i.e. result + copy-to-clipboard button) -->
	<ng-container *ngTemplateOutlet="messageTpl"></ng-container>

	<!-- Post-Message text -->
	<ng-container
		[ngTemplateOutlet]="additionalFormattedDescriptionsTpl"
		[ngTemplateOutletContext]="{ placement: resultViewPlacementEnum.AFTER_MESSAGE }"
	></ng-container>

	<!-- Pre-Notice text -->
	<ng-container
		[ngTemplateOutlet]="additionalFormattedDescriptionsTpl"
		[ngTemplateOutletContext]="{ placement: resultViewPlacementEnum.BEFORE_NOTICE }"
	></ng-container>

	<!-- Additional notice -->
	<p
		*ngIf="resultConfig?.i18n.notice"
		class="notice fs-sx fw-regular mt-3 mb-0"
		[innerText]="getI18nString( false, resultConfig?.i18n.notice )"
	></p>

	<!-- Post-Notice text -->
	<ng-container
		[ngTemplateOutlet]="additionalFormattedDescriptionsTpl"
		[ngTemplateOutletContext]="{ placement: resultViewPlacementEnum.AFTER_NOTICE }"
	></ng-container>

	<!-- Action buttons -->
	<ng-container *ngTemplateOutlet="actionButtonsTpl"></ng-container>
</div>

<!-- TEMPLATES ############################################################# -->
<!-- Message -->
<ng-template #messageTpl>
	<div class="row mx-0 mt-3 justify-content-center align-items-center">

		<!-- Actual message + result -->
		<p class="title col-auto mb-0 ps-0 fw-medium">
			{{ getI18nString( false, resultConfig?.i18n.message ) }}: {{ resultConfig?.result }}
		</p>

		<!-- Copy-to-clipboard button -->
		<button
			*ngIf="resultConfig?.allowCopyToClipboard"
			class="col-auto px-0 bg-transparent border-0 icon-docs"
			type="button"
			(click)="copyItemToClipboard()"
		></button>
	</div>
</ng-template>

<!-- Additional formatted pre-/post message/notice descriptions -->
<ng-template
	#additionalFormattedDescriptionsTpl
	let-placement="placement"
>
	<div
		*ngIf="additionalFormattedDescriptionsMap?.get( placement )?.length"
		class="mt-3"
	>
		<div
			*ngFor="let descriptionItem of additionalFormattedDescriptionsMap?.get( placement )"
			[class]="'fs-sx fw-regular ' + ( descriptionItem.styleClass ?? '' )"
			[innerText]="getI18nString( false, descriptionItem.i18n )"
		></div>
	</div>
</ng-template>

<!-- Action buttons template -->
<ng-template #actionButtonsTpl>
	<div
		*ngIf="resultConfig?.actions?.length > 0"
		class="d-flex flex-wrap justify-content-center mx-auto mt-3"
	>
		<ng-container
			*ngFor="let action of resultConfig?.actions;"
			[ngSwitch]="action.identifier"
		>
			<!-- CLOSE -->
			<button
				*ngSwitchCase="resultActionEnum.CLOSE"
				class="btn abortBtn m-1"
				[class.disabled]="action.isDisabled"
				(click)="onButtonEvent( resultActionEnum.CLOSE )"
			>
				{{ getI18nString( false, 'shared.buttons.close') | uppercase }}
			</button>

			<!-- DOWNLOAD -->
			<app-download-button
				*ngSwitchCase="resultActionEnum.DOWNLOAD"
				class="m-1"
				[buttonLabel]="getI18nString( false, 'shared.buttons.download')"
				[buttonStyleClass]="'text-uppercase'"
				[class.disabled]="action.isDisabled"
				[showIcon]="true"
				[supportedDownloadFormats]="action.supportedDownloadFormats"
				(buttonEvent)="onButtonEvent( resultActionEnum.DOWNLOAD, $event )"
			></app-download-button>
		</ng-container>
	</div>
</ng-template>
